<template>
  <div
      v-loading="loaded"
      :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
  >
      <multiselect
          v-model="temp_value"
          :placeholder="
              placeOtherText ? placeOtherText : $t('lbl_EMPBE_ProductSelect')
          "
          label="title"
          track-by="id"
          :options="GetImageOptions"
          :option-height="104"
          :show-labels="false"
          v-bind="$attrs"
          @input="updateValueByInput"
          :mandatory="$t('Lbl_SelectSearchProduct')"
          :disabled="disabled"
      >
          <template slot="singleLabel" slot-scope="props">
              <img
                  class="img-fluid img-100"
                  :src="props.option.img"
                  alt="#"
              />
              <span class="option__desc">
                  <span>{{ props.option.title }}</span>
              </span>
          </template>

          <template slot="option" slot-scope="props">
              <img
                  v-if="props.option.img"
                  class="img-fluid img-50"
                  :src="props.option.img"
                  alt="#"
              />

              <div class="option__desc">
                  <span>{{ props.option.title }}</span>
                  <span class="option__small">{{ props.option.desc }}</span>
              </div>
          </template>

          <template slot="noResult">
              <span>{{ $t("lbl_EMPBE_NoResultFound") }}</span>
          </template>

          <template slot="noOptions">
              <span>{{ $t("lbl_EMPBE_ListIsEmpty") }}</span>
          </template>
      </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { productService } from '@/_services/product.service';
import { adService } from "../../_services";
// import { PaymentItemService } from '../../_services';
export default {
  components: {
    Multiselect
  },
  props: ['value', 'valueId', 'usagetype', 'supplierId', 'useFirstImage', 'disabled','placeOtherText', 'imgUsageType', 'filterCallback','hotAppId','isHotApp','hotCatIds','HotAppIds', 'refreshToken','isNotblurryType'],
  data() {
    return {

      temp_value: this.value,
      imageOptions: [],
      filteredImageOptions: [], // 新增用于存储异步过滤结果
      loaded: false,
      AfterValue:this.value,
      suppressSelectProdFlag: false,
    };
  },
  computed: {
    GetImageOptions(){
      // 使用异步过滤的结果，如果有的话
      if (this.filteredImageOptions && this.filteredImageOptions.length > 0) {
        return this.filteredImageOptions;
      }
      
      if((!this.hotAppId || this.hotAppId.length === 0) && (!this.hotCatIds || this.hotCatIds.length === 0))  return this.imageOptions;

      var res = this.imageOptions;

      if(this.hotAppId && this.hotAppId.length > 0)
      {
          res = res.filter(item=> {
            var AppData = item.industryIds?.split(',');
            if(this.isHotApp && this.HotAppIds && this.HotAppIds.length > 0) {
              const hasHotAppId = AppData?.includes(this.hotAppId);
              if (!hasHotAppId) return false; 
              
              const hasHotAppIds = AppData?.some(a => this.HotAppIds.includes(a));
              return hasHotAppIds; 
            }

            return AppData?.includes(this.hotAppId)  
          })
      }
      if(this.hotCatIds && this.hotCatIds.length > 0)
      {
          res = res.filter(item=>{
          var CatData = item.catIds?.split(',');
          // 修复这里的逻辑，应该返回布尔值而不是数组
          return CatData?.some(a=>this.hotCatIds.includes(a));
         })
      }
      return res;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId === null || this.supplierId === undefined || this.supplierId === '' ? this.user.empCompanyId : this.supplierId;
    },
  },
  watch: {
    hotCatIds: function (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal) && newVal.length > 0) {
        this.temp_value=[];
        this.updateValue();
        this.updateFilteredOptions();
      }
    },
    hotAppId: function (newVal, oldVal) {
      if(newVal !== oldVal && newVal.length>0){
        this.temp_value=[];
        this.updateValue();
        this.updateFilteredOptions();
      }
    },
    valueId() {
      this.populateOptionByValueId();
    },
    // 外部触发刷新（如上游数据过期后刷新）：重新拉取产品列表，保证选项最新
    refreshToken() {
      this.loadProductByCompanyId();
      this.updateFilteredOptions();
    },
    supplierId() {
      this.loadProductByCompanyId();
    }
  },
  mounted() {
    this.loadProductByCompanyId();
    // 初始化异步过滤
    this.updateFilteredOptions();
  },
  methods: {
    // 异步过滤方法
    async updateFilteredOptions() {
      try {
        if ((!this.hotAppId || this.hotAppId.length === 0) && (!this.hotCatIds || this.hotCatIds.length === 0)) {
          this.filteredImageOptions = this.imageOptions;
          return;
        }

        let res = this.imageOptions;

        if (this.hotAppId && this.hotAppId.length > 0) {
          res = res.filter(item => {
            var AppData = item.industryIds?.split(',');
            if (this.isHotApp && this.HotAppIds && this.HotAppIds.length > 0) {
              const hasHotAppId = AppData?.includes(this.hotAppId);
              if (!hasHotAppId) return false;
              
              const hasHotAppIds = AppData?.some(a => this.HotAppIds.includes(a));
              return hasHotAppIds; 
            }

            return AppData?.includes(this.hotAppId)
          })
        }
        
        if (this.hotCatIds && this.hotCatIds.length > 0) {
          res = res.filter(item => {
            var CatData = item.catIds?.split(',');
            return CatData?.some(a => this.hotCatIds.includes(a));
          })
        }
        
        await new Promise(resolve => setTimeout(resolve, 0));
        
        // 更新过滤后的选项
        this.filteredImageOptions = res;
      } catch (error) {
        this.filteredImageOptions = this.imageOptions;
      }
    },
    updateValueByInput(){
      if (this.suppressSelectProdFlag) {
        this.updateValue();
        return;
      }
      if (this.temp_value != null && this.temp_value.length > 0) {
        this.$set(this.temp_value[0], 'IsSelectProd', true);
      } else if(this.temp_value != null) {
        this.$set(this.temp_value, 'IsSelectProd', true);
      }
      
      this.updateValue();
    },
    updateValue() {
      if(this.temp_value==null)
      {
        this.temp_value=this.AfterValue;
      }
      if (this.temp_value != null && this.temp_value.length > 0) {
        this.$emit('input', this.temp_value[0]);
      } else {
        this.$emit('input', this.temp_value);
      }

      this.AfterValue=this.temp_value;
    },
    getImgUrl(path) {
      return require('../../assets/images/' + path);
    },
    loadProductByCompanyId() {
      var that = this;
      that.imageOptions = [];
      that.loaded = true;
      productService.GetProducWithImage({ companyId: this.companyid })
        .then((res) => {

          if (res.isSuccessful) {
            var langid = localStorage.getItem('currentLangId');

            const options = this.filterCallback ? this.filterCallback(res.data) : res.data;

            that.imageOptions = options.reduce((accu, item) => {
              const isUsageType = item.usageType && (!that.isNotblurryType && item.usageType.toLocaleLowerCase().includes(that.usagetype.toLocaleLowerCase()) || (that.isNotblurryType && item.usageType.toLocaleLowerCase().includes(that.usagetype.toLocaleLowerCase()) &&  !item.usageType.includes('Short')));

              if (!isUsageType) {
                return accu;
              }

              const option = {
                id: item.productId,
                title: langid === '1252' ? item.exhibitNameE : langid === '950' ? item.exhibitNameT : item.exhibitNameS,
                img: item.fileName,
                usagetype: item.usageType,
                catIds: item.catIds,
                industryIds: item.industryIds,
                tagIds: item.tagIds,
                keywordIds: item.keywordIds
              };

              if (that.imgUsageType) {
                const photoData = res.data.filter(x => x.productId == item.productId && x.usageType === that.imgUsageType)
                if (photoData.length > 0) {
                  option.img = photoData[0].fileName;
                }
              }

              // 视频广告：无指定封面时，优先用 ExhibitVideo_Cover 作为缩略图
              const isVideoUsage = that.usagetype
                && String(that.usagetype).toLowerCase().includes('video');
              if (isVideoUsage && (!that.imgUsageType || !option.img || /\.(mp4|webm|mov|avi|flv|mpeg|wmv)(\?|$)/i.test(option.img))) {
                const coverData = res.data.filter(x =>
                  x.productId == item.productId
                  && String(x.usageType || '').toLowerCase().includes('cover')
                  && String(x.usageType || '').toLowerCase().includes('video')
                );
                if (coverData.length > 0) {
                  option.img = coverData[0].fileName;
                }
              }

              // [2025-01-22] [BLK] If cannot find product photo by key (imgUsageType) or useFirstImage is true
              if ((that.imgUsageType && !option.img) || that.useFirstImage) {
                const photoData = res.data.filter(x => x.productId == item.productId && x.usageType === "ExhibitPhoto")
                if (photoData.length > 0) {
                  option.img = photoData[0].fileName;
                }
              }

              if (accu.filter(x => x.id == option.id).length <= 0) {
                accu.push(option);
              }
              
              return accu;
            }, []);

            that.populateOptionByValueId();

            if (that.temp_value.length > 0) {
              that.$emit('input', that.temp_value[0]);
            }
          }
        }).finally(() => {
          that.loaded = false
        })

    },
    populateOptionByValueId() {
      if (this.imageOptions != undefined) {
        this.suppressSelectProdFlag = true;
        this.temp_value = this.imageOptions.filter(x => x.id == this.valueId);
        this.$nextTick(() => {
          this.updateValue();
          this.$nextTick(() => {
            this.suppressSelectProdFlag = false;
          });
        });
      }
    },
  }
};
</script>

<style lang="scss">
.multiselect.multiselect--disabled {
  > .multiselect__tags {
    background-color: #ededed !important;

    > .multiselect__single {
      background-color: #ededed !important;
    }
  }
}

.multiselect {
  position: relative;
  z-index: 5;

  &.multiselect--active {
    z-index: 1200;
  }

  &:hover {
    > .multiselect__select::before {
      color: #616161 !important;
      border-color: #616161 transparent transparent;
    }
  }

  > .multiselect__select {
    width: 1rem !important;
    height: 2rem !important;
    padding: 0 !important;
    right: 0.5rem !important;
    top: 0.125rem !important;

    &::before {
      color: #ccc !important;
      border-color: #ccc transparent transparent;
    }
  }

  > .multiselect__tags {
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 4px;

    > .multiselect__single {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    > .multiselect__placeholder {
      margin-left: 0.5rem;
      color: #898989;
    }
  }
}

.multiselect__content-wrapper {
  position: absolute !important;
  z-index: 1201 !important;
  max-height: min(280px, 50vh) !important;
  overflow-y: auto !important;
}
</style>

<style scoped>
::v-deep .el-loading-mask{
    z-index: 1 !important;
}
</style>